import { connect } from "react-redux";
import { ProgressBar } from "primereact/progressbar";

import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import {
  initCreateRentersRentersInfoScreen,
  createRentersRentersInfo,
  editRentersRentersInfo,
  fetchRentersRentersInfoById,
  uploadImage,
} from "../../../../redux/actions/Renters/RentersRentersInfo";
import { useEffect } from "react";
import { setIsformDirty } from "../../../../redux/actions/common/form";
import CreateRentersRentersInfoComponent from "../../../../component/Renters/RentersRentersInfo/CreateRentersRentersInfo";
import { useParams } from "react-router-dom";

const CreateRentersRentersInfoContainer = (props) => {
  console.log("checkprops on screen ", props);
  const {
    history,
    createRentersRentersInfo,
    editRentersRentersInfo,
    isLoading,
    isRentersRentersInfoCreateSuccess,
    isRentersRentersInfoCreateError,
    isRentersRentersInfoDetailSuccess,
    isRentersRentersInfoDetailError,
    isRentersRentersInfoEditSuccess,
    isRentersRentersInfoEditError,
    isEdit,
    isView,
    initCreateRentersRentersInfoScreen,
    formFieldValueMap,
    fetchRentersRentersInfoById,
    uploadImage,
    imageUploadResponse,
    isUploadImageSuccess,
    isUploadImageError,
    shouldBlockNavigation,
        isVehicleModelDDSuccess,
        isVehicleModelDDError,
  } = props;

  const { id } = useParams
  ();
  const callAPIasync = async() =>{
    initCreateRentersRentersInfoScreen();
   if (isEdit) {
    await fetchRentersRentersInfoById({id:id});
  }
  }
  useEffect(() => {
    callAPIasync()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit]);

 

  const createRentersRentersInfoProps = {
    createRentersRentersInfo,
    initCreateRentersRentersInfoScreen,
    editRentersRentersInfo,
    isLoading,
    isEdit,
    isRentersRentersInfoDetailSuccess,
    isRentersRentersInfoCreateSuccess,
    isRentersRentersInfoEditSuccess,
    isRentersRentersInfoEditError,
    formFieldValueMap,
    shouldBlockNavigation,
    uploadImage,
    imageUploadResponse,
    isUploadImageSuccess,
    isUploadImageError,
        isVehicleModelDDSuccess,
        isVehicleModelDDError,
  };
  const getToastProps = () => {
    if (isRentersRentersInfoCreateSuccess || isRentersRentersInfoEditSuccess) {
      const toastTitle = isEdit
        ? "Renters Info Updated Successfully"
        : "Renters Info Created Successfully";
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle,
        shouldShowToast: true,
      };
    }

    if (
      isRentersRentersInfoCreateError ||
      isRentersRentersInfoDetailError ||
      isRentersRentersInfoEditError
    ) {
      let toastTitle = "Error while Creating Renters Info";
      if (isRentersRentersInfoEditError) {
        toastTitle = "Error while updating  Renters Info";
      } else if (isRentersRentersInfoDetailError) {
        toastTitle =
          "Error while performing operation. Please refresh your browser";
      }

      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle,
        shouldShowToast: true,
      };
    }
  };
  const renderProgressBar = () => {
    return <ProgressBar mode="indeterminate" style={{ height: "6px" }} />;
  };

  return (
    <>
      {isLoading && renderProgressBar()}
      <EzToast {...getToastProps()} />
      <CreateRentersRentersInfoComponent {...createRentersRentersInfoProps} />;
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  console.log("mapState", state);
  return {
    isLoading: selectFromRentersRentersInfoReducer(state, "isLoading"),
   
    isRentersRentersInfoCreateSuccess: selectFromRentersRentersInfoReducer(
      state,
      "isRentersRentersInfoCreateSuccess"
    ),
    isRentersRentersInfoCreateError: selectFromRentersRentersInfoReducer(
      state,
      "isRentersRentersInfoCreateError"
    ),
    isRentersRentersInfoDetailSuccess: selectFromRentersRentersInfoReducer(
      state,
      "isRentersRentersInfoDetailSuccess"
    ),
    isRentersRentersInfoDetailError: selectFromRentersRentersInfoReducer(
      state,
      "isRentersRentersInfoDetailError"
    ),
    isRentersRentersInfoEditSuccess: selectFromRentersRentersInfoReducer(
      state,
      "isRentersRentersInfoEditSuccess"
    ),
    isRentersRentersInfoEditError: selectFromRentersRentersInfoReducer(
      state,
      "isRentersRentersInfoEditError"
    ),
    imageUploadResponse: selectFromRentersRentersInfoReducer(
      state,
      "imageUploadResponse"
    ),
    isUploadImageSuccess: selectFromRentersRentersInfoReducer(
      state,
      "isUploadImageSuccess"
    ),
    isUploadImageError: selectFromRentersRentersInfoReducer(
      state,
      "isUploadImageError"
    ),


    vehicleModelDD: selectFromRentersRentersInfoReducer(
      state,
      "vehicleModelDD"
    ),
    isVehicleModelDDSuccess: selectFromRentersRentersInfoReducer(
      state,
      "isVehicleModelDDSuccess"
    ),
    isVehicleModelDDError: selectFromRentersRentersInfoReducer(
      state,
      "isVehicleModelDDError"
    ),

    formFieldValueMap: selectFromRentersRentersInfoReducer(state, "formFieldValueMap"),
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    initCreateRentersRentersInfoScreen: () => dispatch(initCreateRentersRentersInfoScreen()),
    createRentersRentersInfo: (payload) => dispatch(createRentersRentersInfo(payload)),
    editRentersRentersInfo: (payload) => dispatch(editRentersRentersInfo(payload)),
    shouldBlockNavigation: (isFormDirty) =>dispatch(setIsformDirty(isFormDirty)),
    uploadImage:(payload) => dispatch(uploadImage(payload)),
    fetchRentersRentersInfoById: (payload) =>
      dispatch(fetchRentersRentersInfoById(payload)),

  };
};

const selectFromRentersRentersInfoReducer = (state, path) => {
  return selectRentersRentersInfoReducer(state)[path];
};

const selectRentersRentersInfoReducer = ({ RentersRentersInfoReducer }) => {
  return RentersRentersInfoReducer;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateRentersRentersInfoContainer);
